(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('sopValid', {
        templateUrl: 'views/components/views/sopValid/sopValid.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'sopValidService', function ($stateParams, stateService, utilityService, translateService, modalService, sopValidService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let sopKeyno = $stateParams.sop_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                menu: {},
                itemsListValids: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE CALLS

            async function loadEdit() {
                vm.model.menu = (await sopValidService.getMenu({ sop_keyno: sopKeyno }))[0];
            }
            
            async function loadSopValids() {
                if (utilityService.validateParmsValue(vm.model.menu.sop_keyno) !== true) return;
                
                return vm.model.itemsListValids = await sopValidService.listSopValids({ sop_keyno: vm.model.menu.sop_keyno });
            }

            // #endregion LOAD PROCEDURE CALLS

            // #region TOGGLE FUNCTIONS
            
            vm.toggleChosen = function (item) {
                item = item?.item ? item.item : item;
                
                if (item.item_id === '0' || item.item_id === '-1') return;
                
                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                }
            };

            // #endregion TOGGLE FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                let currentData = vm.model.itemsListValids;
                let selectedItems = [];

                currentData.forEach((item) => {
                    selectedItems.push({
                        item_id: item.item_id,
                        item_is_selected: item.item_is_selected
                    });
                });

                sopValidService.saveObj({ records: selectedItems }).then(function (response) {
                    if (response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadSopValids();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
